import React, { useState } from 'react';
import '../pages/ResultsDashboard.css';
import './SummaryCards.css';
import './StrategyRowCard.css';
import './ResultsControls.css';
import SummaryCards from './SummaryCards';
import StrategyRowCard from './StrategyRowCard';
import ResultsControls from './ResultsControls';
import { IconInfo } from './Icons';
import { PnlScalingInfoModal } from './PnlScalingInfoModal';
import { getDataSourceNote, isVectorEntity, getResultsNavLabel } from '../utils/activeEntity';

const SAMPLE_SUMMARY = {
  winners: 40,
  losers: 9,
  largestWin: { strategyName: 'Grass Fed Prime Beef (Current version 2.1C)', weeklyTotal: 567.5 },
  largestLoss: { strategyName: 'Filet Mignon', weeklyTotal: -1052.5 },
};

function SamplePnlScalingInfo() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="results-pnl-scale-info"
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Open PnL scaling note"
        onClick={() => setOpen(true)}
      >
        <IconInfo size={14} />
      </button>
      <PnlScalingInfoModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

const SAMPLE_STRATEGIES = [
  {
    strategyName: 'Grass Fed Prime Beef (Current version 2.1C)',
    weeklyTotal: 567.5,
    dailyPnL: { Monday: 279, Tuesday: 147, Wednesday: 141.5, Thursday: 0, Friday: 0 },
  },
  {
    strategyName: 'Grass Fed Prime Beef',
    weeklyTotal: 298,
    dailyPnL: { Monday: 79, Tuesday: 139, Wednesday: 80, Thursday: 0, Friday: 0 },
  },
  {
    strategyName: 'ES Momentum Scalper',
    weeklyTotal: -125.5,
    dailyPnL: { Monday: 50, Tuesday: -80, Wednesday: -95.5, Thursday: 0, Friday: 0 },
  },
];

/** Sample preview for Vector Results tab when beta-ended message is shown */
function VectorResultsSamplePreview() {
  return (
    <div className="results-dash-page" style={{ opacity: 0.9 }}>
      <div className="results-dash-header">
        <div>
          <div className="results-controls-row">
            <div className="results-select-group">
              <label className="results-select-label" style={{ textAlign: 'left' }}>{getResultsNavLabel()} Spreadsheet</label>
              <select className="results-sheet-select-inline" disabled value="Current Results">
                <option>Current Results</option>
              </select>
            </div>
            <div className="results-vector-filters-row">
              <div className="results-select-group">
                <label className="results-select-label">Contract Type</label>
                <div className="results-contract-type-chips">
                  <button type="button" className="results-contract-type-chip active" disabled>NQ</button>
                  <button type="button" className="results-contract-type-chip" disabled>MNQ</button>
                </div>
              </div>
              <div className="results-select-group results-contract-size-group">
                <div className="results-contract-label-row">
                  <label className="results-select-label">Default Contract Size Multiplier</label>
                  <SamplePnlScalingInfo />
                </div>
                <input type="number" className="results-contract-size-input" value="1" readOnly disabled />
              </div>
              <div className="results-select-group">
                <label className="results-select-label" style={{ opacity: 0 }}>Reset</label>
                <button type="button" className="results-reset-filter-btn" disabled>Reset Filters</button>
              </div>
            </div>
          </div>
          <p className="results-dash-week">Week of March 9, 2026</p>
          <p className="results-dash-subtitle">
            Current weekly results are loaded automatically for fast viewing.
          </p>
        </div>
        <div className="results-dash-actions">
          <button type="button" className="secondary" disabled>View raw data</button>
        </div>
      </div>
      <div className="results-data-notice" style={{ marginTop: '1rem' }}>
        <span className="results-data-notice-icon">i</span>
        <span className="results-data-notice-text">
          {getDataSourceNote({ withDisclaimer: false })}{' '}
          {isVectorEntity()
            ? 'If you don\u2019t see the latest data, the spreadsheet owners need to update it first.'
            : ''}
        </span>
      </div>
      <SummaryCards summary={SAMPLE_SUMMARY} contractType="NQ" contractSize={1} />
      <ResultsControls
        search=""
        onSearch={() => {}}
        showLosersOnly={false}
        onToggleLosers={() => {}}
        sortBy="priority"
        onSortChange={() => {}}
        categoryOptions={['1:1 Strategies']}
        selectedCategory={null}
        onCategoryChange={() => {}}
        hideLosersToggle={true}
      />
      <div className="results-group-list">
        {SAMPLE_STRATEGIES.map((s) => (
          <StrategyRowCard
            key={s.strategyName}
            strategy={s}
            category="1:1 Strategies"
            contractType="NQ"
            contractSize={1}
          />
        ))}
      </div>
    </div>
  );
}

export default VectorResultsSamplePreview;
